// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-deduction.page.title': 'Team Member Deductions',
    'team-member-deduction.page.cancel.title': 'Cancelled Team Member Deductions',
    'team-member-deduction.page.search_results': 'Search Results',
    'team-member-deduction.page.search.title': 'Find Team Member Deductions',
    'team-member-deduction.page.edit.title': 'Edit Team Member Deduction',
    'team-member-deduction.page.all': 'All',

    'team-member-deduction.button.cancel': 'Cancel',
    'team-member-deduction.button.select': 'Select',
    'team-member-deduction.button.find': 'Find Team Member Deductions',
    'team-member-deduction.button.search': 'Apply',
    'team-member-deduction.button.print': 'Print',
    'team-member-deduction.button.edit': 'Edit',
    'team-member-deduction.button.void': 'Void',
    'team-member-deduction.button.reset': 'Reset',
    'team-member-deduction.button.record_payment': 'Record Payment',

    'team-member-deduction.label.account_number': 'Account Number',
    'team-member-deduction.label.instructions': 'Instructions',
    'team-member-deduction.label.entity_name': 'Contact',
    'team-member-deduction.label.entity_address_line_1': 'Address Line 1',
    'team-member-deduction.label.entity_address_line_2': 'Address Line 2',
    'team-member-deduction.label.entity_address_line_3': 'Address Line 3',
    'team-member-deduction.label.entity_province': 'Province',
    'team-member-deduction.label.entity_postal_code': 'Postal Code',
    'team-member-deduction.label.entity_country_id': 'Country',

    'team-member-deduction.placeholder.search': 'Search Team Member Deductions',

    'team-member-deduction.link.create_first_team_member_deduction': 'Click here to create your first Team Member Deduction',
    'team-member-deduction.link.team_member_deductions': ' Return to Team Member Deductions',
    'team-member-deduction.link.cancel': 'Cancelled Team Member Deductions',
    'team-member-deduction.link.retry': 'Click here to retry',

    'team-member-deduction.checkbox.all': 'Check All',
    'team-member-deduction.checkbox.actions_label': 'with selected',

    'team-member-deduction.label.grand_total': 'Total',
    'team-member-deduction.label.subtotal': 'Subtotal',
    'team-member-deduction.label.team_member_deduction': 'Team Member Deduction',
    'team-member-deduction.label.team_member_name': 'Team Member',
    'team-member-deduction.label.income_account': 'Income Account',
    'team-member-deduction.label.expense_name': 'Expense',
    'team-member-deduction.label.transaction_date': 'Transaction Date',
    'team-member-deduction.label.team_member_deduction_number': 'Team Member Deduction Number',
    'team-member-deduction.label.notes': 'Notes',
    'team-member-deduction.label.currency_name': 'Currency',
    'team-member-deduction.label.balance': 'Balance',
    'team-member-deduction.label.currency_amount_in_cents': 'Amount',
    'team-member-deduction.label.pay_to': 'Pay to:',
    'team-member-deduction.label.on_behalf_of': 'On behalf of:',

    'team-member-deduction.sort.field_label': 'Field',
    'team-member-deduction.sort.direction_label': 'Direction',
    'team-member-deduction.sort.direction_ascending': 'Ascending',
    'team-member-deduction.sort.direction_descending': 'Descending',

    'team-member-deduction.modal.title.team_member_deduction_cancel': 'Void Team Member Deduction',
    'team-member-deduction.modal.title.team_member_deduction_delete_permanently': 'Delete Team Member Deduction',
    'team-member-deduction.modal.title.team_member_deduction_restore': 'Restore Team Member Deduction',

    'team-member-deduction.modal.message.team_member_deduction_cancel': 'Are you sure that you want to void this deduction ? | Are you sure that you want to void these deductions ?',
    'team-member-deduction.modal.message.team_member_deduction_delete_permanently':
        'Are you sure that you want to permanently delete this Team Member Deduction? This action cannot be undone. | Are you sure that you want to permanently delete these Team Member Deductions? This action cannot be undone.',
    'team-member-deduction.modal.message.team_member_deduction_restore': 'Are you sure that you want to restore this Team Member Deduction? | Are you sure that you want to restore these Team Member Deductions?',

    'team-member-deduction.success.message.team_member_deduction_created': 'Your Team Member Deduction has been created',
    'team-member-deduction.success.message.team_member_deduction_updated': 'Your Team Member Deduction has been updated',
    'team-member-deduction.success.message.team_member_deduction_restored': 'Your Team Member Deduction has been restored | All selected Team Member Deductions were restored',
    'team-member-deduction.success.message.team_member_deduction_deleted': 'Your Team Member Deduction has been permanently deleted | All selected Team Member Deductions were permanently deleted',
    'team-member-deduction.success.message.cancelled_team_member_deductions': 'Your Team Member Deduction was voided | All selected Team Member Deductions were voided',

    'team-member-deduction.error.message.cancelled_team_member_deductions': 'This Team Member Deduction was already voided | These Team Member Deductions were already voided',
    'team-member-deduction.error.message.team_member_deduction_deleted': 'This Team Member Deduction was already permanently deleted | These Team Member Deductions were already permanently deleted',
    'team-member-deduction.error.message.team_member_deduction_restored': 'This Team Member Deduction was already restored | These Team Member Deductions were already restored',
    'team-member-deduction.error.message.error_loading_page': 'Sorry, there was an error loading Team Member Deduction.| Sorry, there was an error loading Team Member Deductions.',

    'team-member-deduction.message.search.no_cancelled_team_member_deductions': "You don't have any cancelled Team Member Deductions.",
};
